import React, { useState } from "react";
import "./SectionHeader.css";
import dots from "../../images/dots.svg";

export default function DraggableBlocks({
  onDragStart,
  type,
  index,
  setDraggedType,
  toggleBlock = () => {},
}) {
  const [isDragging, setIsDragging] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleDragStart = (e) => {
    e.stopPropagation();
    setIsDragging(true);
    if (onDragStart) {
      onDragStart(e);
    }
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setDraggedType("");
    setTimeout(() => {
      toggleBlock();
    }, 1500);
  };

  const handleClick = () => {
    setIsClicked(true);
  };

  return (
    <div
      style={{ position: "relative" }}
      key={index}
      className="parentContainer"
    >
      {/* Top element */}
      <div
        draggable
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        style={{
          position: "absolute",
          width: "100%",
          top: 0,
          left: 0,
          zIndex: isDragging ? 1 : 2,
        }}
      >
        <div
          className={`outer-container  ${isDragging ? "drag-ghost" : ""}`}
          style={{
            borderRight: `${isDragging ? "5px solid #6700B2" : ""}`,
            borderBottom: `${isDragging ? "5px solid #6700B2" : ""}`,
            borderTop: `${isDragging ? "1.5px solid #6700B2" : ""}`,
            borderLeft: `${isDragging ? "1.5px solid #6700B2" : ""}`,
          }}
        >
          <div className="drag-handle top-0 h-100">
            <div className="icon_tamplet">
              <img
                src={dots}
                className="img-fluid"
                alt="dots"
                style={{ pointerEvents: "none" }}
              />
            </div>
          </div>
          <div className="section-header-container">
            <div className="section-header">
              <span className="section-title">
                {type === "small_header" ? "small" : type}{" "}
                {type === "paragraph" ? "" : "header"} (
                {type === "chapter"
                  ? "32"
                  : type === "section"
                  ? "24"
                  : type === "small_header"
                  ? "20"
                  : "18"}
                )
              </span>
              <span className="drag_hover">
                drag to the book to add textbook block
              </span>
            </div>
            {type === "chapter" ? (
              <div className="section-buttons">
                <div className="short_bar">
                  <div className="button" style={{ width: "100%" }}></div>
                </div>
                <div className="long_bar">
                  <div className="button" style={{ width: "100%" }}></div>
                </div>
              </div>
            ) : type === "section" ? (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "80px", height: "10px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "160px", height: "10px" }}
                ></div>
              </div>
            ) : type === "small_header" ? (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "50px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
              </div>
            ) : (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "50px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "30px", height: "8px" }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Bottom element */}
      <div
        style={{
          position: "absolute",
          width: "100%",
          top: 0,
          left: 0,
          zIndex: isDragging ? 2 : 1,
          backgroundColor: "lightgray",
          pointerEvents: "none",
          display: `${isDragging ? "" : "none"}`,
        }}
      >
        <div className={`outer-container_disable`} onClick={handleClick}>
          <div className={`drag-handle disable_chapter`}>
            <div className="icon_tamplet">
              <img src={dots} className="img-fluid" alt="dots" />
            </div>
          </div>
          <div
            className={`section-header-container disable_title
          `}
          >
            <div className="section-header">
              <span className="section-title">
                {type === "small_header" ? "small" : type}{" "}
                {type === "paragraph" ? "" : "header"} (
                {type === "chapter"
                  ? "32"
                  : type === "section"
                  ? "24"
                  : type === "small_header"
                  ? "20"
                  : "18"}
                )
              </span>
              <span className="drag_hover">
                drag to the book to add textbook block
              </span>
            </div>
            {type === "chapter" ? (
              <div className="section-buttons">
                <div className="short_bar">
                  <div className="button" style={{ width: "100%" }}></div>
                </div>
                <div className="long_bar">
                  <div className="button" style={{ width: "100%" }}></div>
                </div>
              </div>
            ) : type === "section" ? (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "80px", height: "10px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "160px", height: "10px" }}
                ></div>
              </div>
            ) : type === "small_header" ? (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "50px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
              </div>
            ) : (
              <div className="section-buttons">
                <div
                  className="button"
                  style={{ width: "50px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "100px", height: "8px" }}
                ></div>
                <div
                  className="button"
                  style={{ width: "30px", height: "8px" }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>

    // {<div
    //   className="parentContainer"
    //   draggable
    //   onDragStart={handleDragStart}
    //   onDragEnd={handleDragEnd}
    //   key={index}
    // >
    //   <div
    //     className={` ${isDragging ? "outer-container_disable" : "outer-container"}`}
    //     onClick={handleClick}
    //   >
    //     <div className={`drag-handle ${isDragging ? "disable_chapter" : ""}`}>
    //       <div className="icon_tamplet">
    //         <img src={dots} className="img-fluid" alt="dots" />
    //       </div>
    //     </div>
    //     <div
    //       className={`section-header-container ${
    //         isDragging ? "disable_title" : ""
    //       }`}
    //     >
    //       <div className="section-header">
    //         <span className="section-title">
    //           {type === "small_header" ? "small" : type}{" "}
    //           {type === "paragraph" ? "" : "header"} (
    //           {type === "chapter"
    //             ? "32"
    //             : type === "section"
    //             ? "24"
    //             : type === "small_header"
    //             ? "20"
    //             : "18"}
    //           )
    //         </span>
    //         <span className="drag_hover">
    //           drag to the book to add textbook block
    //         </span>
    //       </div>
    //       {type === "chapter" ? (
    //         <div className="section-buttons">
    //           <div className="short_bar">
    //             <div className="button" style={{ width: "100%" }}></div>
    //           </div>
    //           <div className="long_bar">
    //             <div className="button" style={{ width: "100%" }}></div>
    //           </div>
    //         </div>
    //       ) : type === "section" ? (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "80px", height: "10px" }}></div>
    //           <div className="button" style={{ width: "160px", height: "10px" }}></div>
    //         </div>
    //       ) : type === "small_header" ? (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "50px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //         </div>
    //       ) : (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "50px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "30px", height: "8px" }}></div>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    //   <div className={`outer-container drag-ghost ${isDragging ? "visible" : ""}`}>
    //     <div className="drag-handle">
    //       <div className="icon_tamplet">
    //         <img src={dots} className="img-fluid" alt="dots" />
    //       </div>
    //     </div>
    //     <div className="section-header-container">
    //       <div className="section-header">
    //         <span className="section-title">
    //           {type === "small_header" ? "small" : type}{" "}
    //           {type === "paragraph" ? "" : "header"} (
    //           {type === "chapter"
    //             ? "32"
    //             : type === "section"
    //             ? "24"
    //             : type === "small_header"
    //             ? "20"
    //             : "18"}
    //           )
    //         </span>
    //         <span className="drag_hover">
    //           drag to the book to add textbook block
    //         </span>
    //       </div>
    //       {type === "chapter" ? (
    //         <div className="section-buttons">
    //           <div className="short_bar">
    //             <div className="button" style={{ width: "100%" }}></div>
    //           </div>
    //           <div className="long_bar">
    //             <div className="button" style={{ width: "100%" }}></div>
    //           </div>
    //         </div>
    //       ) : type === "section" ? (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "80px", height: "10px" }}></div>
    //           <div className="button" style={{ width: "160px", height: "10px" }}></div>
    //         </div>
    //       ) : type === "small_header" ? (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "50px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //         </div>
    //       ) : (
    //         <div className="section-buttons">
    //           <div className="button" style={{ width: "50px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "100px", height: "8px" }}></div>
    //           <div className="button" style={{ width: "30px", height: "8px" }}></div>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>}
  );
}
